var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',[_vm._v("组件测试")]),_c('button',{on:{"click":_vm.toShow}},[_vm._v("点击显示子组件")]),_c(_vm.show_component,{tag:"component"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }